import { GAME_ID, REDUX_ACTIONS } from 'a/cutItOut/data/constants';

export const initialState = {
  currentPicture: null,
  feedbackPicture: null,
  // coordinates of placeholder on the screen
  placeholderLayout: { },
};

const placeholderReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_PLACEHOLDER_LAYOUT:
      return {
        ...state,
        placeholderLayout: action.payload.layout,
      };
    case REDUX_ACTIONS.SET_PLACEHOLDER_PICTURE:
      return {
        ...state,
        currentPicture: action.payload.currentPicture,
      };
    case REDUX_ACTIONS.SET_FEEDBACK_PICTURE:
      return {
        ...state,
        feedbackPicture: action.payload.feedbackPicture,
      };
    case REDUX_ACTIONS.INIT_PLACEHOLDER_PICTURE:
      return {
        ...state,
        currentPicture: null,
        feedbackPicture: null,
      };
    default:
      return state;
  }
};

export default placeholderReducer;
